export default {
  'bill.insurer': 'health cover',
  'org.bsb': 'BSB',
  'org.npi': 'Australian Business Number',
  'org.taxId': 'Australian Company Number',
  'bill.tax': 'GST'
};